import Songs from '../Components/Songs';

const Index = () => {
  return (
    <div className='Index'>
      {/* <h2>Index</h2> */}
      <Songs />
    </div>
  );
};

export default Index;
